import { useEffect } from 'react';
import { setToken } from '../../store/slices/authSlice';
import { useAppDispatch } from '../../store/store';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../../store/selectors/authSelectors';
import { fetchCurrentUser } from '../api/authApi';

export const useAuth = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const user = useSelector(selectUser);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const storedToken = localStorage.getItem('authToken');
        const isOnAuthRoute = location.pathname.startsWith('/login');
        const urlToken = searchParams.get('auth_token');

        const isPublicRoute =
            location.pathname === '/' ||
            location.pathname === '/about' ||
            location.pathname === '/privacy-policy' ||
            location.pathname === '/terms-of-use' ||
            location.pathname === '/features' ||
            location.pathname === '/contact' ||
            location.pathname === '/creativity' ||
            location.pathname === '/brand-analytics' ||
            location.pathname === '/teamwork' ||
            location.pathname === '/version-control' ||
            location.pathname === '/approval-process' ||
            location.pathname === '/pricing' ||
            location.pathname === '/onboarding';

        if (isPublicRoute) {
            return;
        }
        if (storedToken) {
            dispatch(setToken(storedToken));
        }

        if (isOnAuthRoute && urlToken) {
            dispatch(setToken(urlToken));

            if (!user?.id) {
                dispatch(fetchCurrentUser());
            }
        }

        console.log('isOnAuthRoute', isOnAuthRoute);
        console.log('storedToken', storedToken);
        console.log('urlToken', urlToken);

        if (!storedToken && !urlToken && !isOnAuthRoute) {
            navigate('/login');
        }
    }, [dispatch, navigate, location.pathname]);

    useEffect(() => {
        const isOnAuthRoute = location.pathname.startsWith('/login');
        const searchParams = new URLSearchParams(location.search);
        const urlToken = searchParams.get('auth_token');

        // redirect if not social login and email verified
        // if urlToken is present the AuthPage will handle it
        if (user && isOnAuthRoute && !urlToken) {
            navigate('/dashboard');
        }
    }, [user, navigate]);
};
